import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, FormFeedback, Alert } from 'reactstrap';
import { FaPlusCircle } from 'react-icons/fa';
import FaTrash from "../../imgs/deleteIcon.png"
import FaPencilAlt from "../../imgs/lapiz.svg"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

class TableAreas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],

            modalEditarDatosNamArea: "",
            modalEditarDatosPassword: "",
            invalidNamArea: false,
            invalidPassword: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalNuevo = this.modalNuevo.bind(this);
        this.modalEditar = this.modalEditar.bind(this);
        this.modalEliminar = this.modalEliminar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.borrarSeleccion = this.borrarSeleccion.bind(this);
        this.editarSeleccion = this.editarSeleccion.bind(this);
        this.agregarDato = this.agregarDato.bind(this);
        this.handleChangeModal = this.handleChangeModal.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleChangeModal(e) {
        const idVariable = e.target.name;
        switch (idVariable) {
            case "modalEditarDatosNamArea":
                if (e.target.value.length <= 80) { // PASO DE 64 A 80
                    await this.setState({
                        modalEditarDatosNamArea: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Área</Label>
                                            <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Password</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            case "modalEditarDatosPassword":
                if (e.target.value.length <= 20) {
                    await this.setState({
                        modalEditarDatosPassword: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Área</Label>
                                            <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Password</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando las áreas existentes, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/Allareas");
            await this.setState({
                datosTraidos: response.data
            })
            if (bool === true) {
                this.toggle();
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }

    }

    async modalNuevo() {
        await this.setState({
            invalidNamArea: false,
            invalidPassword: false,
            auxSeqArea: 999,
            modalEditarDatosNamArea: "",
            modalEditarDatosPassword: "",
        })
        this.setState({
            modalTitulo: "Agregar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Área</Label>
                                <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Password</Label>
                                <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.agregarDato} color="success">Agregar</Button>
            </div>
        })
        this.toggle();
    }
    async agregarDato() {
        var hayError = false;
        //var regexNumber = /^[0-9]+$/;
        //var regexString = /^[a-zA-Z]+$/;
        if (this.state.modalEditarDatosNamArea === undefined || this.state.modalEditarDatosNamArea === "" || this.state.modalEditarDatosNamArea === null || this.state.modalEditarDatosNamArea.length <= 1 || this.state.modalEditarDatosNamArea.length >= 81) { //PASO DE 65 A 81
            hayError = true;
            this.setState({
                invalidNamArea: true,
            })
        } else {
            this.setState({
                invalidNamArea: false,
            })
        }
        if (this.state.modalEditarDatosPassword === undefined || this.state.modalEditarDatosPassword === "" || this.state.modalEditarDatosPassword === null || this.state.modalEditarDatosPassword.length <= 1 || this.state.modalEditarDatosPassword.length >= 21) {
            hayError = true;
            this.setState({
                invalidPassword: true,
            })
        } else {
            this.setState({
                invalidPassword: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Área</Label>
                                            <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Password</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                seqArea: 1,
                namArea: this.state.modalEditarDatosNamArea,
                password: this.state.modalEditarDatosPassword,
            }
            try {
                const response = await axios.post(OBTENER_URL_SERVICIO + "/area/new", envioDatos);
                if (response.data.tipo === "EXITO") {
                    this.setState({
                        modalTitulo: "Exito",
                        modalMensaje:
                            <div>
                                <p>¡Dato agregado!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "ERROR") {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    async modalEditar(event) {
        const datos = event.target.id;
        const arrayDatos = datos.split("///");
        await this.setState({
            auxSeqArea: arrayDatos[0],
            modalEditarDatosNamArea: arrayDatos[1],
            modalEditarDatosPassword: arrayDatos[2],
        })
        this.setState({
            invalidNamArea: false,
            invalidPassword: false,
            modalTitulo: "Editar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Área</Label>
                                <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Password</Label>
                                <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.editarSeleccion} color="warning">Editar</Button>
            </div>
        })
        this.toggle();
    }
    async editarSeleccion() {
        var hayError = false;
        //var regexNumber = /^[0-9]+$/;
        //var regexString = /^[a-zA-Z]+$/;
        if (this.state.modalEditarDatosNamArea === undefined || this.state.modalEditarDatosNamArea === "" || this.state.modalEditarDatosNamArea === null || this.state.modalEditarDatosNamArea.length <= 1 || this.state.modalEditarDatosNamArea.length >= 81) { //PASO DE 65 A 81
            hayError = true;
            this.setState({
                invalidNamArea: true,
            })
        } else {
            this.setState({
                invalidNamArea: false,
            })
        }
        if (this.state.modalEditarDatosPassword === undefined || this.state.modalEditarDatosPassword === "" || this.state.modalEditarDatosPassword === null || this.state.modalEditarDatosPassword.length <= 1 || this.state.modalEditarDatosPassword.length >= 21) {
            hayError = true;
            this.setState({
                invalidPassword: true,
            })
        } else {
            this.setState({
                invalidPassword: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Área</Label>
                                            <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosNamArea} bsSize="sm" type="text" name="modalEditarDatosNamArea" id="modalEditarDatosNamArea" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Password</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalEditarDatosPassword} bsSize="sm" type="text" name="modalEditarDatosPassword" id="modalEditarDatosPassword" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 20 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                seqArea: this.state.auxSeqArea,
                namArea: this.state.modalEditarDatosNamArea,
                password: this.state.modalEditarDatosPassword,
            }
            try {
                const response = await axios.put(OBTENER_URL_SERVICIO + "/area/" + this.state.auxSeqArea, envioDatos);
                if (response.data.tipo === "Actualizado") {
                    this.setState({
                        modalTitulo: "Actualizado",
                        modalMensaje:
                            <div>
                                <p>¡Área actualizada con éxito!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "Error") {
                        this.setState({
                            modalTitulo: "Area no encontrada",
                            modalMensaje:
                                <div>
                                    <p>No se encontró el área para eliminar.</p>
                                    <p>¡Quizás alguien se adelantó!</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    modalEliminar(event) {
        this.setState({
            modalTitulo: "Eliminar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>¡ATENCIÓN!</Label>
                            <br />
                            <Label>Se eliminará el dato seleccionado.</Label>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} onClick={this.borrarSeleccion} color="danger">Eliminar</Button>
            </div>
        })
        this.toggle();
    }
    async borrarSeleccion(event) {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })

        try {
            const response = await axios.delete(OBTENER_URL_SERVICIO + "/area/" + event.target.id);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "EXITO",
                    modalMensaje:
                        <div>
                            <p>¡Área eliminada con éxito!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "NO ENCONTRADO") {
                    this.setState({
                        modalTitulo: "Area no encontrada",
                        modalMensaje:
                            <div>
                                <p>No se encontró el área para eliminar.</p>
                                <p>¡Quizás alguien se adelantó!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>Por favor, valida que el área no contenga agentes o módulos.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }

    }

    render() {
        var datosTabla =
            <Alert color="primary">
                No hay Áreas inscritas.
        </Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre Área</th>
                            <th>Contraseña</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            return (
                                <tr key={p.seqArea}>
                                    <th scope="row">{p.seqArea}</th>
                                    <td>{p.namArea}</td>
                                    <td>{p.password}</td>
                                    <td><Button size="sm" color="warning" id={p.seqArea + "///" + p.namArea + "///" + p.password} onClick={this.modalEditar} > <img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p.seqArea + "///" + p.namArea + "///" + p.password} alt="editar" /></Button>{" | | "}<Button size="sm" color="danger" id={p.seqArea} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p.seqArea} alt="borrar" /></Button></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
        }
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Áreas </Label> <Button className="btn btn-success float-right" onClick={this.modalNuevo}><FaPlusCircle></FaPlusCircle> Agregar Áreas</Button></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TableAreas;